import { render, staticRenderFns } from "./OrgArea.vue?vue&type=template&id=4c9e7f3e"
import script from "./OrgArea.vue?vue&type=script&lang=js"
export * from "./OrgArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports